<template>
  <div class="realTime">
    <div class="top_box">
      <span>实时数据</span>
      <el-radio-group v-model="realTime.timeType" @change="realTimeChange">
        <el-radio-button v-for="item in timeOption" :key="item.code" :label="item.code">{{item.desc}}</el-radio-button>
      </el-radio-group>
      <el-date-picker
        class="date-picker"
        v-model="realTime.dataTime"
        type="daterange"
        value-format="yyyy-MM-dd"
        range-separator="-"   
        start-placeholder="开始时间"
        end-placeholder="结束时间"
        @change="formTimeChange"
        :picker-options="pickerOptions"
        :editable="false">
      </el-date-picker>
      <div class="tab">
        <span @click="realTimeTabChange(0)" :class="{active: realTime.realTimeTab === 0}">今日累计销售额</span>
        <span @click="realTimeTabChange(1)" :class="{active: realTime.realTimeTab === 1}">今日分时销售额</span>
      </div>
    </div>
    <div class="content_box">
      <div class="num_box">
        <div class="g-flex-c amount_item">
          <div class="sum">
            <div>
              <p>
                <el-tooltip class="item" effect="light" content="已支付+退款中+退款失败的订单原价合计" placement="right">
                  <span class="title">总销售额 <i class="el-icon-question"></i></span>
                </el-tooltip>
              <p><span class="sum_money">{{geUnit(realTimeData.amountGun).num}}</span><span class="unit">{{geUnit(realTimeData.amountGun).unit}}</span></p>
              <p>
                <template v-if="[0, 1].includes(realTime.timeType)">
                  <span class="text">较前一天</span><img :src="getIcon(realTimeData.amountGunRatioYTD)"><span :class="['per', getClass(realTimeData.amountGunRatioYTD)]">{{numProcessing(realTimeData.amountGunRatioYTD)}}%</span>
                  <span class="text">较上周同日</span><img :src="getIcon(realTimeData.amountGunRatioLW)"><span :class="['per', getClass(realTimeData.amountGunRatioLW)]">{{numProcessing(realTimeData.amountGunRatioLW)}}%</span>
                </template>
                <template v-if="[2, 3].includes(realTime.timeType) || (realTime.dataTime && realTime.dataTime.length)"><span class="text">较上周期</span><img :src="getIcon(realTimeData.amountGunRatioLC)"><span :class="['per', getClass(realTimeData.amountGunRatioLC)]">{{numProcessing(realTimeData.amountGunRatioLC)}}%</span></template>
              </p>
            </div>
          </div>
          <!-- <div class="estimate">
            <p v-show="realTime.timeType === 0" class="title">预估流水</p>
            <p v-show="realTime.timeType === 0"><span class="money">{{geUnit(realTimeData.estimatedFlow).num}}</span><span class="unit">{{geUnit(realTimeData.estimatedFlow).unit}}</span></p>
          </div> -->
          <div class="estimate">
            <el-tooltip class="item" effect="light" content="加油金额总金额-通道费总金额-商家承担营销总金额+商家优惠券售卖总金额" placement="right">
              <span class="title" style="margin-bottom: 8px;">实际结算总金额 <i class="el-icon-question"></i></span>
            </el-tooltip>
            <p><span class="sum_money">{{geUnit(realTimeData.actualSettlementAmount).num}}</span><span class="unit">{{geUnit(realTimeData.actualSettlementAmount).unit}}</span></p>
          </div>
          <div class="estimate">
            <p class="title">平台补贴总金额</p>
            <p><span class="sum_money">{{geUnit(realTimeData.platformSubsidyAmount).num}}</span><span class="unit">{{geUnit(realTimeData.platformSubsidyAmount).unit}}</span></p>
          </div>
        </div>
        <div class="g-flex-start amount_item">
          <div class="small">
            <p>
              <el-tooltip class="item" effect="light" content="已支付+退款中+退款失败的订单数量合计" placement="right">
                <span class="title">总订单 <i class="el-icon-question"></i></span>
              </el-tooltip>
            </p>
            <p><span class="money">{{geUnit(realTimeData.orderCount).num}}</span><span class="unit">{{geUnit(realTimeData.orderCount, '笔').unit}}</span></p>
            <p v-if="[0, 1].includes(realTime.timeType)"><span class="text">较前一天</span><img :src="getIcon(realTimeData.orderCountRatioYTD)"><span :class="['per', getClass(realTimeData.orderCountRatioYTD)]">{{numProcessing(realTimeData.orderCountRatioYTD)}}%</span></p>
            <p v-if="[0, 1].includes(realTime.timeType)"><span class="text">较上周同日</span><img :src="getIcon(realTimeData.orderCountRatioLW)"><span :class="['per', getClass(realTimeData.orderCountRatioLW)]">{{numProcessing(realTimeData.orderCountRatioLW)}}%</span></p>
            <p v-if="[2, 3].includes(realTime.timeType)  || (realTime.dataTime && realTime.dataTime.length)"><span class="text">较上周期</span><img :src="getIcon(realTimeData.orderCountRatioLC)"><span :class="['per', getClass(realTimeData.orderCountRatioLC)]">{{numProcessing(realTimeData.orderCountRatioLC)}}%</span></p>
          </div>
          <div class="small">
            <p>
              <el-tooltip class="item" effect="light" content="已支付+退款中+退款失败的订单升数合计" placement="right">
                <span class="title">总升数 <i class="el-icon-question"></i></span>
              </el-tooltip>
            </p>
            <p><span class="money">{{geUnit(realTimeData.litre).num}}</span><span class="unit">{{geUnit(realTimeData.litre, '升').unit}}</span></p>
            <p v-if="[0, 1].includes(realTime.timeType)"><span class="text">较前一天</span><img :src="getIcon(realTimeData.litreRatioYTD)"><span :class="['per', getClass(realTimeData.litreRatioYTD)]">{{numProcessing(realTimeData.litreRatioYTD)}}%</span></p>
            <p v-if="[0, 1].includes(realTime.timeType)"><span class="text">较上周同日</span><img :src="getIcon(realTimeData.litreRatioLW)"><span :class="['per', getClass(realTimeData.litreRatioLW)]">{{numProcessing(realTimeData.litreRatioLW)}}%</span></p>
            <p v-if="[2, 3].includes(realTime.timeType) || (realTime.dataTime && realTime.dataTime.length)"><span class="text">较上周期</span><img :src="getIcon(realTimeData.litreRatioLC)"><span :class="['per', getClass(realTimeData.litreRatioLC)]">{{numProcessing(realTimeData.litreRatioLC)}}%</span></p>
          </div>
          <!-- <div class="small">
            <p>
              <el-tooltip class="item" effect="light" content="已支付+退款中+退款失败的订单商家优惠金额合计" placement="right">
                <span class="title">营销成本 <i class="el-icon-question"></i></span>
              </el-tooltip>
            </p>
            <p><span class="money">{{geUnit(realTimeData.marketingCostTotal).num}}</span><span class="unit">{{geUnit(realTimeData.marketingCostTotal).unit}}</span></p>
            <p v-if="[0, 1].includes(realTime.timeType)"><span class="text">较前一天</span><img :src="getIcon(realTimeData.marketingCostRatioYTD)"><span :class="['per', getClass(realTimeData.marketingCostRatioYTD)]">{{numProcessing(realTimeData.marketingCostRatioYTD)}}%</span></p>
            <p v-if="[0, 1].includes(realTime.timeType)"><span class="text">较上周同日</span><img :src="getIcon(realTimeData.marketingCostRatioLW)"><span :class="['per', getClass(realTimeData.marketingCostRatioLW)]">{{numProcessing(realTimeData.marketingCostRatioLW)}}%</span></p>
            <p v-if="[2, 3].includes(realTime.timeType) || (realTime.dataTime && realTime.dataTime.length)"><span class="text">较上周期</span><img :src="getIcon(realTimeData.marketingCostRatioLC	)"><span :class="['per', getClass(realTimeData.marketingCostRatioLC)]">{{numProcessing(realTimeData.marketingCostRatioLC)}}%</span></p>
          </div> -->
        </div>
      </div>
      <div id="realTime_chart"></div>
    </div>
    <div class="bottomBox" v-show="realTime.timeType === 0">
      <img class="robot" src="../../../assets/image/workPlatform/robot.png" alt="">
      <div class="rightBox">
        <p class="msg" :title="businessAnalysis">经营分析：{{businessAnalysis}}</p>
        <div class="btn_box">
          <span class="btn" v-if="btnJurisdiction.isSendCoupon" @click="sendCoupon">去发券</span>
          <span class="btn" v-if="btnJurisdiction.isReport" @click="sendReport">去报名</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import echarts from 'echarts'
import rise from '../../../assets/image/workPlatform/rise.png'
import fall from '../../../assets/image/workPlatform/fall.png'
import { getRealtimeData, getRealtimeChart } from '@/api/businessAnalysis'

export default {
  props: {
    btnJurisdiction: {
      type: Object,
      default () {
        return {}
      }
    },
    time: {
      type: Number,
      default : 3000
    }
  },
  data () {
    return {
      gasId: '',
      realTime: {
        timeType: 0,
        dataTime: [],
        realTimeTab: 0
      },
      dataTime: '',
      timeOption: [
        {
          code: 0,
          desc: '今日'
        },
        {
          code: 1,
          desc: '昨日'
        },
        {
          code: 2,
          desc: '近7天'
        },
        {
          code: 3,
          desc: '近30天'
        }
      ],
      realTimeData: {},
      businessAnalysis: '',
      echartsDom: null,
      randomMsg: '您好，智慧管家持续护航中～',
      drawData: null,
      pickerMinDate: '',
      isReport: false,
      isSendCoupon: false,
      pickerOptions: {
        onPick: (obj) => {
          this.pickerMinDate = new Date(obj.minDate)
        },
        disabledDate:(time)=> {
          let startTime = time.getTime() > dayjs().subtract(1, 'day').valueOf()
          if (this.pickerMinDate) {
            let ET = dayjs(this.pickerMinDate).add(2, 'month').format('YYYY-MM-DD 00:00:00')
            let ST = dayjs(this.pickerMinDate).subtract(2, 'month').format('YYYY-MM-DD 00:00:00')
            let endTime = time.getTime() > dayjs(ET).valueOf() || time.getTime() < dayjs(ST).valueOf()
            return startTime || endTime
          }else{
              return startTime
          }
        }  
      },
      timmer: null
    }
  },
  methods: {
    init (gasId) {
      this.gasId = gasId
      this.getRealtimeData()
      this.getRealtimeChart()
      this.timmer = null
      clearInterval(this.timmer)
      this.timmer = window.setInterval(() => {
        this.getRealtimeData()
        this.getRealtimeChart()
      },this.time * 1000)
    },
    // 图标
    getIcon (num) {
      if (num > 0) return rise
      if (num < 0) return fall
    },
    // 类名 
    getClass (num) {
      if (num > 0) return 'red'
      if (num < 0) return 'green'
    },
    // 单位
    geUnit (num, unit) {
      let number = num || num === 0 ? (num >= 1000000 ? Math.round(num/100)/100 : num.toFixed(2)) : '-'
      let txt = unit || '元'
      return {
        num: number,
        unit: num >= 1000000 ? '万' + txt : txt
      }
    },
    numProcessing (num) {
      if (num || num === 0) {
        return Math.abs(num * 100).toFixed(2)
      } else {
        return '-'
      }
    },
    realTimeChange () {
      this.$track.clickEvent('经营分析-时间组件', 1655798957)
      this.realTime.dataTime = []
      this.pickerMinDate = ""
      this.getRealtimeData()
    },
    formTimeChange () {
      this.$track.clickEvent('经营分析-时间组件', 1655798957)
      // console.log(this.realTime.dataTime)
      if (this.realTime.dataTime && this.realTime.dataTime.length) {
        this.realTime.timeType = -1
      } else {
        this.realTime.timeType = 0
        this.pickerMinDate = ""
      }
      this.getRealtimeData()
    },
    // 切换折线图类别
    realTimeTabChange (val) {
      val === 0 ? this.$track.clickEvent('经营分析-今日累计销售额', 1655798958) : this.$track.clickEvent('经营分析-今日分时销售额', 1655798959)
      this.realTime.realTimeTab = val
      this.echartsDom.dispose()
      this.getRealtimeChart()
    },
    drawLine () {
      this.echartsDom = null
      this.echartsDom = echarts.init(document.getElementById('realTime_chart'))
      let legend1 = ['今日销售额', '昨日销售额', '上周同日销售额', '今日预估流水']
      let legend2 = ['今日销售额', '昨日销售额', '上周同日销售额']
      let xData = []
      for(let i = 0; i < 25; i+=0.5 ){
        let H = i%1 === 0 ? i : parseInt(i)
        let N = i%1 === 0 ? ':00' : ':30'
        xData.push(H+N)
      }
      let data = this.drawData.seriesDto.map(item => {
        item.data.unshift(0)
        return {
          ...item,
          type: 'line'
        }
      })
      this.echartsDom.setOption({
        color: ['#3377FF', '#FFAC52', '#ADCD40', '#48C672'],
        tooltip: {
          trigger: 'axis',
          backgroundColor: '#fff',
          formatter: (params) => {
            var relVal = xData[params[0].dataIndex]
              for (var i = 0, l = params.length; i < l; i++) {
                relVal += '<br/>' + params[i].marker + params[i].seriesName + '： ' + (this.geUnit(params[i].value).num) + '元'
              }
              return relVal
          },
          axisPointer: {
            type: 'line',
            lineStyle: {
              type: 'dashed'
            },
            label: {
              backgroundColor: '#6a7985'
            }
          },
          textStyle: {
            color: '#606266'
          }
        },
        legend: {
          data: this.realTime.realTimeTab === 0 ? legend1 : legend2,
          bottom: '0px'
        },
        grid: {
          left: '3%',
          right: 10,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          // type: 'value',
          boundaryGap: false,
          data: [0, ...this.drawData.axis],
          nameTextStyle: {
            color:'#666'
          },
          axisLine: {
            lineStyle: {
              color:'#EAEAEA'
            }
          },
          axisLabel: {
            color:'#666',
            interval: 1
          },
          axisTick: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          splitLine: {
            lineStyle: {
              type:'dashed',
              color:'#EAEAEA'
            }
          },
          axisLabel: {
            formatter: '{value}元'
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false
          }
        },
        series: data
      })
    },
    async getRealtimeData () {
      try {
        let data = {
          gasId: this.gasId || this.$store.getters.userInfo.gasId,
          queryType: this.realTime.timeType
        }
        if (this.realTime.timeType === -1) {
          data.beginDate = this.realTime.dataTime[0]
          data.endDate = this.realTime.dataTime[1]
        }
        const { code, result } = await getRealtimeData(data)
        if (code !== 200) return
        this.businessAnalysis = result.businessAnalysis
        this.realTimeData = result.realTimeData
        this.isReport = result.isReport
        this.isSendCoupon = result.isSendCoupon
      } catch (error) {
        console.log(error)
      }
    },
    async getRealtimeChart () {
      try {
        let data = {
          gasId: this.gasId,
          businessType: this.realTime.realTimeTab
        }
        const { code, result } = await getRealtimeChart(data)
        if (code !== 200) return
        this.drawData = result
        this.drawLine()
      } catch (error) {
        console.log(error)
      }
    },
    sendCoupon () {
      this.$track.clickEvent('经营分析-去发券按钮', 1655798953)
      this.$router.push({path: '/vipMarket/vipDraw'})
    },
    sendReport () {
      this.$track.clickEvent('经营分析-去提报按钮', 1655798954)
      this.$router.push({path: '/promotion/centerShow'})
    }
  },
  beforeDestroy () {
    clearInterval(this.timmer)
  }
}
</script>
<style lang="less" scoped>
@import url('../style/index.less');
/deep/.realTime .el-radio-button__orig-radio:checked+.el-radio-button__inner{
  color: #409EFF;
  background-color: #fff;
  border-color: #409EFF;
  box-shadow: -1px 0 0 0 #409eff;
}
/deep/.el-range-editor.el-input__inner{
  padding: 0 10px;
}
/deep/.el-date-editor--daterange.el-input, .el-date-editor--daterange.el-input__inner, .el-date-editor--timerange.el-input, .el-date-editor--timerange.el-input__inner{
  width: 320px;
}
</style>